<template>
  <InternalOrExternalLink
    v-if="actionUrl && imageUrl"
    :href="actionUrl"
    data-test-id="hero-image"
    @click="$trackEvent($customerEvents.CLICKED_HERO_IMAGE, { hero_image_url: actionUrl })"
  >
    <q-img
      :src="imageUrl"
      :height="height"
      :position="position"
    />
  </InternalOrExternalLink>
  <q-img
    v-else-if="imageUrl"
    :src="imageUrl"
    :height="height"
    :position="position"
    data-test-id="hero-image"
  />
</template>

<script>
import InternalOrExternalLink from 'src/modules/consumer/components/InternalOrExternalLink'

export default {
  name: 'HeroImage',
  components: {
    InternalOrExternalLink
  },
  props: {
    imageHeight: {
      type: Number,
      default: undefined
    },
    imagePosition: {
      type: Object,
      default: undefined
    },
    imageUrl: {
      type: String,
      default: undefined
    },
    actionUrl: {
      type: String,
      default: undefined
    }
  },
  computed: {
    height () {
      if (!this.imageHeight || this.imageHeight === '') return
      return `${this.imageHeight}px`
    },
    position () {
      if (!this.imagePosition) return
      const { x = 50, y = 50 } = this.imagePosition
      return `${x}% ${y}%`
    }
  }
}
</script>
